<template lang="pug">
  div.vkb-nak-chart
    highcharts(ref="highcharts" :options="type === 'pie' ? pieChartOptions : chartOptions")
    a.btn-back(v-if="level > 0" @click="$emit('go-back')") < Go back to Level {{ level }}

</template>

<script>
export default {
  name: 'index_chart',

  props: {
    data: {
      type: Array,
      default: () => []
    },

    color: {
      type: String,
      default: '#7cb5ec'
    },

    name: {
      type: String,
      default: ''
    },

    max: {
      type: Number,
      default: 0
    },

    type: {
      type: String,
      default: ''
    },

    level: {
      type: Number,
      default: 0
    }
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          // zoomType: 'x'
        },

        credits: {
          enabled: false
        },

        boost: {
          enabled: true,
          allowForce:true,
          usePreallocated:true,
          useGPUTranslations: false
        },

        title: {
          text: ''
        },

        tooltip: {
          valueDecimals: 2
        },

        yAxis: {
          labels: {
            enabled: true
          },
          title: {
            text: ''
          },
          min: 0,
          max: this.max + 20,
          //tickPositions: [ 80, 100, 120, 140, 160, 180, 200, 220, 240 ]
          tickAmount: 8,
        },

        xAxis: {
          type: 'datetime'
        },

        plotOptions: {
          line: {
            color: this.color,
            enableMouseTracking: true,
            turboThreshold: 10000
          }
        },

        series: [{
          data: this.data,
          lineWidth: 0.5,
          name: this.name,
        }]
      };
    },

    pieChartOptions() {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },

        credits: {
          enabled: false
        },

        title: {
          text: ''
        },

        tooltip: {
          pointFormat: this.level > 0
            ? '<b>{point.label}</b>: {point.percentage:.0f}% ({point.y:.0f}%)'
            : '<b>{point.label}</b>: {point.percentage:.0f}%'
        },

        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              className: 'font-weight-normal',
              format: this.level > 0
                ? '{point.label}: <b>{point.percentage:.0f}% ({point.y:.0f}%)</b>'
                : '{point.label}: <b>{point.percentage:.0f}%</b>'
            },
            events: {
              click: (e) => this.$emit('select-level', e)
            }
          }
        },

        series: [{
          name: this.name,
          colorByPoint: true,
          data: this.data
        }]
      };
    }
  }
};
</script>

<style scoped>
.btn-back {
  color: #E51C0C;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/apps/index/chart.vue